// extracted by mini-css-extract-plugin
module.exports = {"AppHeader":"AppHeader_AppHeader__20Kkr","logo":"AppHeader_logo__2lmFr"};